module.exports = __webpack_public_path__ + "img/room.050cc16c.png";